import { isEmpty, find } from 'lodash/fp';
import i18next from 'i18next';
import { JOB_TYPE_I18N } from 'app/components/composite/TriggerConfiguration/constants.js';

export const getFilterOptions = (candidates, currentJobUid) => {
    if (isEmpty(candidates)) {
        return {};
    }
    const filteredCandidates = currentJobUid
        ? candidates.filter((candidate) => candidate?.definitionRef.uid !== currentJobUid)
        : candidates;

    return filteredCandidates.reduce(
        (acc, curr) => {
            const targetTable = curr?.managedTable || curr?.targetTable;
            const type = curr?.operationType || curr?.operationKind;
            const environment = curr?.environmentRef;
            const project = curr?.projectRef;

            if (type && !find({ value: type }, acc.type)) {
                acc.type.push({
                    name: i18next.t(`jobs:definitions.jobType.${JOB_TYPE_I18N[type] ?? type}`),
                    value: type,
                    type: 'type'
                });
            }
            if (environment && !find({ value: environment.uid }, acc.environment)) {
                acc.environment.push({
                    name: environment.name,
                    value: environment.uid,
                    type: 'environment'
                });
            }
            if (isEmpty(targetTable)) {
                return acc;
            }
            if (!find({ value: targetTable?.database }, acc.database)) {
                acc.database.push({
                    name: targetTable?.database,
                    value: targetTable?.database,
                    type: 'database'
                });
            }
            if (!find({ value: targetTable?.schema }, acc.schema)) {
                acc.schema.push({
                    name: targetTable?.schema,
                    value: targetTable?.schema,
                    type: 'schema'
                });
            }
            if (!find({ value: targetTable?.table }, acc.table)) {
                acc.table.push({
                    name: targetTable?.table,
                    value: targetTable?.table,
                    type: 'table'
                });
            }
            if (project && !find({ value: project.id }, acc.project)) {
                acc.project.push({
                    name: project.name,
                    value: project.id,
                    type: 'project'
                });
            }
            return acc;
        },
        { database: [], schema: [], table: [], type: [], environment: [], project: [] }
    );
};

export const filterValues = (values, filters, currentJobUid) => {
    const { type, database, schema, table, searchTerm, environment, project } = filters;

    return values?.filter((job) => {
        const targetTable = job.managedTable || job?.targetTable;
        const kind = job?.operationType || job?.operationKind;
        const jobName = job?.definitionRef?.name;
        const environmentUid = job?.environmentRef?.uid;
        const projectId = job?.projectRef?.id;

        return (
            (!currentJobUid || job?.definitionRef?.uid !== currentJobUid) &&
            (!type || type.value === kind) &&
            (!database || database.value === targetTable?.database) &&
            (!schema || schema.value === targetTable?.schema) &&
            (!table || table.value === targetTable?.table) &&
            (!environment || environment.value === environmentUid) &&
            (!project || Number(project.value) === projectId) &&
            (!searchTerm || jobName?.toLowerCase().includes(searchTerm.value?.toLowerCase()))
        );
    });
};
